import { action, computed, observable, runInAction, toJS } from "mobx";
import { ApiResult, FieldType, ViewModelBase, getHistory } from "@shoothill/core";
import React, { useState, useContext } from "react";
import { AppUrls } from "AppUrls";
import { getUrlSearchParams } from "@shoothill/core";

// Model
import { RegisterApplicantModel } from "Globals/Models/Domain/Applicant/RegisterApplicantModel";
import { RegisterApplicantDTO } from "Globals/Models/DTO/RegisterApplicantDTO";
import { RegistrationTokenDTO } from "Globals/Models/DTO/RegistrationTokenDTO";

export default class RegisterApplicantViewModel extends ViewModelBase<RegisterApplicantModel> {
    @observable public tokenValid?: boolean;
    @observable public errorMessage: string = "";
    constructor() {
        super(new RegisterApplicantModel());
    }

    public registerApplicant = async (): Promise<void> => {
        this.setIsLoading(true);
        try {
            let hasToken = await this.getTokenFromUrl();
            let isMyModelValid: boolean = await this.isModelValid();
            if (hasToken && isMyModelValid) {
                let upsert: RegisterApplicantDTO = this.model.toDto();
                const apiResult = await this.Post<RegisterApplicantDTO>(AppUrls.Server.Applicant.RegisterApplicant, upsert);
                if (apiResult.wasSuccessful) {
                    this.model.fromDto(apiResult.payload);
                    console.info("RegisterApplicantRequest:Successful");
                    getHistory().push("/");
                } else {
                    console.error("RegisterApplicantRequest:Error", apiResult.errors);
                    runInAction(() => {
                        this.errorMessage = apiResult.errors[0].message;
                    });
                }
            }
        } catch (exception) {
            console.log("Error:", exception);
        } finally {
            this.setIsLoading(false);
        }
    };

    public getTokenFromUrl = async (): Promise<boolean> => {
        const urlSearchParams = getUrlSearchParams();
        const registrationToken = urlSearchParams.get("token");
        if (registrationToken) {
            this.model.setValue("token", registrationToken);
            return await this.verifyRegistrationTokenAsync();
        }
        return false;
    };

    @action
    public verifyRegistrationTokenAsync = async (): Promise<boolean> => {
        let apiResult = await this.Post<RegistrationTokenDTO>(AppUrls.Server.Applicant.VerifyToken, { token: this.model.token });
        if (apiResult.wasSuccessful == false) {
            runInAction(() => {
                this.errorMessage = "Error: Token issue please contact admin";
            });
            return false;
        }
        return apiResult.wasSuccessful;
    };

    public async isFieldValid(fieldName: keyof FieldType<RegisterApplicantModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
